import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { formatCurrency, formatCurrencyInFiat } from '@wolffun/system-currency';

const TotalBalance = ({
  className,
  nativeBalance: amount,
  fiatBalance,
  isWrongNetwork = true
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, styles.container)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.name
  }, "Other Currencies")), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.coin
  }, !isWrongNetwork && amount ? formatCurrency(amount, {
    withCurrency: true,
    trimWholeFraction: true
  }) : '-- WBNB'), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.subCoin, styles.space)
  }, !isWrongNetwork && amount ? formatCurrencyInFiat(amount, {
    withCurrency: true,
    trimWholeFraction: true
  }) : '-- USD'), /*#__PURE__*/React.createElement("div", {
    className: styles.coin
  }, !isWrongNetwork && fiatBalance ? formatCurrency(fiatBalance, {
    withCurrency: true,
    trimWholeFraction: true
  }) : '-- USDT'), /*#__PURE__*/React.createElement("div", {
    className: styles.subCoin
  }, !isWrongNetwork && fiatBalance ? formatCurrencyInFiat(fiatBalance, {
    withCurrency: true,
    trimWholeFraction: true
  }) : '-- USD'), isWrongNetwork && /*#__PURE__*/React.createElement("div", {
    className: styles.wrongNetwork
  }, /*#__PURE__*/React.createElement("span", null, "Wrong network"))));
};

export default TotalBalance;